var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClickChatbot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.85,156.54c-12.92,6.69-22.82,18.2-29.94,30.87S403.2,214,398.66,227.8l-4,71.21c15-25.55,27.08-55.59,30.34-85l-10-.89c6.71-1,12.34-5.88,15.92-11.64s5.42-12.39,7.22-18.93L426,184.33A45.25,45.25,0,0,0,444.85,156.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,315.69s-32.62-39-32.24-76.26h13.17s-14.31-9.4-13.17-14.67,1.5-25.21,1.5-25.21l12,3s-9-4.51-10.16-11.66,2.63-40.26,2.63-40.26,14.68,15.43,19.2,31.23,16.37,34.24,12.89,82.39S392.46,315.69,392.46,315.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,319.38s35.33-23.53,43.18-53.56l-10.59-2.88s13.56-4.43,13.81-8.91,4.3-20.6,4.3-20.6l-10.34-.21s8.25-1.66,10.72-7.16,6.7-32.94,6.7-32.94S451.59,202.31,444.5,214,423.84,238,416.1,277.45,409,319.38,409,319.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.15,184.66a2.13,2.13,0,0,1,.11.41l.28,1.2c.24,1.08.59,2.64,1,4.63s1,4.48,1.54,7.35,1.25,6.13,1.91,9.75c1.39,7.24,2.86,15.89,4.38,25.51s2.93,20.24,4.24,31.4,2.27,21.84,3,31.55,1.26,18.47,1.56,25.83c.19,3.68.27,7,.37,9.94s.15,5.44.17,7.5.05,3.63.06,4.74v1.24c0,.27,0,.42,0,.42a1.8,1.8,0,0,1,0-.42c0-.31,0-.71-.05-1.24,0-1.11-.09-2.7-.16-4.74s-.14-4.57-.27-7.49-.23-6.26-.44-9.93c-.34-7.36-.92-16.11-1.67-25.81s-1.8-20.37-3.08-31.53-2.75-21.76-4.2-31.39-2.92-18.27-4.26-25.51c-.64-3.63-1.29-6.89-1.84-9.77s-1-5.34-1.45-7.36-.71-3.56-.93-4.65c-.1-.51-.17-.91-.23-1.21A2.26,2.26,0,0,1,375.15,184.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.93,339.58s-29.84-33.84-39.11-54.3l7-3c-5.08.84-10.27-1.34-14.2-4.65S334.8,270,332,265.69l9.21-1.55a34.25,34.25,0,0,1-20.13-15.59c10.87,1.79,20.71,7.76,28.82,15.22,6.56,6,12.12,13.06,17.46,20.22a69,69,0,0,1,6.79,11.15C379.13,305.5,388,327.15,387.93,339.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.64,212.82a1.77,1.77,0,0,1-.14.35c-.12.24-.27.57-.46,1-.43.88-1.05,2.14-1.83,3.75s-1.77,3.61-2.88,5.94-2.39,4.95-3.74,7.89c-2.76,5.86-5.92,12.89-9.33,20.75s-7,16.57-10.54,25.78-6.76,18.07-9.55,26.17-5.16,15.43-7.06,21.62c-1,3.08-1.8,5.9-2.55,8.36s-1.37,4.59-1.87,6.33-.9,3.06-1.17,4l-.32,1a2.47,2.47,0,0,1-.13.35,1.87,1.87,0,0,1,.08-.37q.09-.39.27-1.05c.25-.95.61-2.3,1.08-4s1.06-3.88,1.78-6.35,1.51-5.3,2.47-8.39c1.86-6.2,4.22-13.55,7-21.67s6-17,9.52-26.2,7.19-17.92,10.59-25.78,6.64-14.87,9.44-20.71c1.37-2.94,2.68-5.56,3.81-7.87s2.13-4.29,3-5.9l1.91-3.71q.33-.6.51-1A2.83,2.83,0,0,1,452.64,212.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.46,354.09a4.4,4.4,0,0,1-.13-.63c-.07-.46-.17-1.06-.28-1.79s-.26-1.74-.46-2.84-.39-2.37-.69-3.75c-.53-2.77-1.3-6.05-2.27-9.65s-2.25-7.5-3.76-11.53-3.19-7.78-4.81-11.14-3.24-6.31-4.67-8.74c-.69-1.23-1.38-2.3-2-3.26s-1.1-1.78-1.54-2.44l-1-1.53a2.56,2.56,0,0,1-.31-.56,3.31,3.31,0,0,1,.4.5l1.05,1.48c.46.64,1,1.44,1.61,2.39s1.32,2,2,3.23c1.48,2.42,3.11,5.37,4.79,8.72s3.33,7.13,4.87,11.17,2.74,8,3.73,11.59,1.68,6.91,2.17,9.7c.28,1.39.44,2.66.61,3.77s.3,2.07.38,2.86.14,1.34.18,1.81A2.58,2.58,0,0,1,390.46,354.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.52,
    y: 346.13,
    width: 65.32,
    height: 13.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.75 359.44 377.81 404.24 417.28 404.24 423.87 359.44 370.75 359.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.84,359.44c0,.15-12.36.26-27.6.26s-27.6-.11-27.6-.26,12.36-.26,27.6-.26S425.84,359.3,425.84,359.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.36,103.16a28.71,28.71,0,0,1-4.36,9.32l4.29,4h0L341.59,133l-.43.2s15.84-11.06,20.22-14.67c3.61-3,13.27-9.12,14.06-15.08a5.11,5.11,0,0,0-2.84-5.23,4,4,0,0,0-4.17.33s4.26-5,.89-8.28-6-.71-6-.71,4.17-6.35.3-9.87a5,5,0,0,0-5.65-.3l1.57-1.68L367.63,69a5.43,5.43,0,0,0,0-7.5,5.28,5.28,0,0,0-7.57.06L337.3,85.38l1.16-13c.29-3.37-4.26-5.81-6.28-4.57,0,0-3.11,1.21-4,6.48C327.59,78.27,323.36,103.16,323.36,103.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.36,103.16s0-.22.08-.65.16-1.07.29-1.89c.27-1.68.66-4.12,1.17-7.27l1.9-11.52q.56-3.37,1.19-7.21a12.34,12.34,0,0,1,1.17-3.86,6.78,6.78,0,0,1,2.95-3.1l0,0a3.46,3.46,0,0,1,2.6-.19A6.27,6.27,0,0,1,337,68.77a4.94,4.94,0,0,1,1.53,2.28c.07.23.09.47.14.7s0,.49,0,.72l-.12,1.37q-.48,5.52-1,11.56l-.42-.19,20.73-21.66c.47-.48.93-1,1.4-1.46a10.37,10.37,0,0,1,1.52-1.42,5.64,5.64,0,0,1,4.12-.89,5.49,5.49,0,0,1,4.44,6.54,6,6,0,0,1-.83,2.06A12.09,12.09,0,0,1,367.09,70l-2.94,3.15-6,6.39-.35-.45a5.51,5.51,0,0,1,3.91-.63,5.34,5.34,0,0,1,1.59.63,2.42,2.42,0,0,1,.68.55,5,5,0,0,1,.56.66,5.44,5.44,0,0,1,1,3.2,12.49,12.49,0,0,1-2,6.17l-.44-.36a4.1,4.1,0,0,1,4.07-.8A5.87,5.87,0,0,1,369,89.61a5,5,0,0,1,.74.72l.35.4.27.46a5.08,5.08,0,0,1,.21,4,11.34,11.34,0,0,1-1.93,3.49l-.37-.41a4.3,4.3,0,0,1,4.1-.5,5.36,5.36,0,0,1,3.38,4.87,7.47,7.47,0,0,1-.32,2,13.06,13.06,0,0,1-1.88,3.47c-3.21,4.11-7.38,7-11.13,9.85s-7.46,5.65-11,8.2l-10.15,7.15-.21-.36.43-.2-.05.35L323.2,116.59h.19l-.1.1-.1-.09-4.27-4-.07-.07.06-.08a29.48,29.48,0,0,0,3.6-6.73c.31-.81.51-1.45.64-1.88s.21-.64.21-.64a18.17,18.17,0,0,1-.74,2.56,28.37,28.37,0,0,1-3.53,6.83v-.15c1.24,1.15,2.62,2.42,4.3,4h-.19l.09-.1.11.09,18.34,16.46.24.21-.29.13-.43.2L341,133l10.12-7.19c3.52-2.56,7.25-5.21,10.95-8.21s7.9-5.76,11-9.78a12.34,12.34,0,0,0,1.79-3.31,7.29,7.29,0,0,0,.3-1.84,5,5,0,0,0-.4-1.81,4.83,4.83,0,0,0-2.64-2.56,3.77,3.77,0,0,0-3.59.45L367,99.88l1.22-1.52a10.52,10.52,0,0,0,1.81-3.3,4.48,4.48,0,0,0-.17-3.61A5.67,5.67,0,0,0,367,89.09a3.54,3.54,0,0,0-3.49.66L362.13,91l.95-1.59a11.83,11.83,0,0,0,1.9-5.86,4.35,4.35,0,0,0-3.37-4.49,4.92,4.92,0,0,0-3.5.58l-1.59.88,1.24-1.32,6-6.39q1.49-1.58,2.94-3.15A11,11,0,0,0,368,68.07a5.47,5.47,0,0,0,.75-1.86A5,5,0,0,0,368,62.4a5,5,0,0,0-3.23-2.07,5.05,5.05,0,0,0-3.71.79,10.08,10.08,0,0,0-1.44,1.35l-1.4,1.46L337.47,85.54,337,86l.07-.68c.36-4,.71-7.88,1.05-11.55a7.09,7.09,0,0,0,0-2.64,4.54,4.54,0,0,0-1.39-2.08,5.7,5.7,0,0,0-2.16-1.2,3.07,3.07,0,0,0-2.28.13h0l0,0a6.43,6.43,0,0,0-2.75,2.9,11.83,11.83,0,0,0-1.15,3.74c-.44,2.55-.86,5-1.24,7.21-.78,4.48-1.45,8.34-2,11.5s-1,5.58-1.28,7.25c-.15.82-.26,1.44-.35,1.88S323.36,103.16,323.36,103.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.36,106.27h.3a4.25,4.25,0,0,1,4.25,4.25v30.86a4.24,4.24,0,0,1-4.24,4.24h-.3a4.25,4.25,0,0,1-4.25-4.25V110.52a4.24,4.24,0,0,1,4.24-4.24Z",
    transform: "translate(11.86 279.22) rotate(-46.93)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,139.69s.24.2.75.49a4.22,4.22,0,0,0,4.17,0,5.31,5.31,0,0,0,1.55-1.49,4.07,4.07,0,0,0-.22-4.84l-23-21.43a4,4,0,0,0-4-.87,4.55,4.55,0,0,0-2.76,2.88,4,4,0,0,0,.83,3.73c.95.95,2,1.89,2.95,2.79l10.29,9.71,6.9,6.57,1.86,1.81a5.3,5.3,0,0,1,.62.66,6,6,0,0,1-.7-.58l-1.93-1.73-7-6.44-10.37-9.61c-1-.92-2-1.8-3-2.82a4.53,4.53,0,0,1-1-4.24,5.15,5.15,0,0,1,3.13-3.27,4.57,4.57,0,0,1,4.51,1c9,8.41,17.1,16,22.91,21.6a4.42,4.42,0,0,1,.17,5.27,5.29,5.29,0,0,1-1.68,1.54,4.31,4.31,0,0,1-1.84.53,4.24,4.24,0,0,1-2.52-.65A2.83,2.83,0,0,1,335.78,139.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,88a36.74,36.74,0,0,1,4.15-4.85,35.83,35.83,0,0,1,4.56-4.46,36.71,36.71,0,0,1-4.14,4.85A35.5,35.5,0,0,1,349.52,88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.14,94.89a12.88,12.88,0,0,1,2.38-3,13.41,13.41,0,0,1,2.79-2.58,12.58,12.58,0,0,1-2.38,3A12.85,12.85,0,0,1,358.14,94.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.27,104.06a12.91,12.91,0,0,1,2.38-3,12.52,12.52,0,0,1,2.8-2.57,13,13,0,0,1-2.38,3A12.73,12.73,0,0,1,363.27,104.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35,55.88a37.83,37.83,0,0,1-2.52-6.12,38.56,38.56,0,0,1-2-6.31,38.43,38.43,0,0,1,2.52,6.12A38.56,38.56,0,0,1,362.35,55.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,57.33a64,64,0,0,1,4.53-7.18,63.48,63.48,0,0,1,5-6.86,64.28,64.28,0,0,1-4.54,7.18A62.69,62.69,0,0,1,368.3,57.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63,62.42a43.22,43.22,0,0,1,6.68-1.7,42.28,42.28,0,0,1,6.79-1.15,40.58,40.58,0,0,1-6.67,1.71A41.56,41.56,0,0,1,372.63,62.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.93 274.4 53.82 404.23 62.27 404.23 95.17 274.4 85.93 274.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.41 274.4 176.45 404.23 168 404.23 137.16 274.4 146.41 274.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.31 402.32 111.47 402.32 110 253.31 119.84 253.31 121.31 402.32",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.51,
    y: 165.8,
    width: 138.83,
    height: 88.94,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.12,
    y: 273.04,
    width: 69.68,
    height: 8.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73,243.14a8.48,8.48,0,0,1,.1,1.63h-.19c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a4.12,4.12,0,0,1,.07-.76,2.67,2.67,0,0,1,.07.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84h-.19A10.77,10.77,0,0,1,54.73,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07,243.14a10.77,10.77,0,0,1,.09,1.63H65c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49.05-3.32.09-6,.11-8,0-.89,0-1.61.07-2.19a2.67,2.67,0,0,1,.07-.76,3.75,3.75,0,0,1,.06.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84H65A8.48,8.48,0,0,1,65.07,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,243.14a10.77,10.77,0,0,1,.09,1.63H75.3c-.14-4.35-.24-18.76-.24-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.25,35.84H75.3A9.71,9.71,0,0,1,75.4,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,243.14a9.71,9.71,0,0,1,.1,1.63h-.19c-.15-4.35-.25-18.76-.25-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89.05-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.24,35.84h-.19A10.77,10.77,0,0,1,85.73,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.06,243.14a8.48,8.48,0,0,1,.1,1.63H96c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49.05-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a4.12,4.12,0,0,1,.07-.76,2.67,2.67,0,0,1,.07.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84H96A10.77,10.77,0,0,1,96.06,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4,243.14a10.77,10.77,0,0,1,.09,1.63h-.19c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49,0-3.32.09-6,.11-8,0-.89,0-1.61.07-2.19a2.67,2.67,0,0,1,.07-.76,3.75,3.75,0,0,1,.06.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84h-.19A8.48,8.48,0,0,1,106.4,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,243.14a10.77,10.77,0,0,1,.09,1.63h-.19c-.14-4.35-.24-18.76-.24-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.25,35.84h-.19A9.71,9.71,0,0,1,116.73,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06,243.14a9.71,9.71,0,0,1,.1,1.63H127c-.15-4.35-.25-18.76-.25-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.24,35.84H127A10.77,10.77,0,0,1,127.06,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.39,243.14a8.48,8.48,0,0,1,.1,1.63h-.19c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89.05-1.61.06-2.19a4.12,4.12,0,0,1,.07-.76,2.67,2.67,0,0,1,.07.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84h-.19A10.77,10.77,0,0,1,137.39,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,243.14a10.77,10.77,0,0,1,.09,1.63h-.19c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49.05-3.32.09-6,.11-8,0-.89,0-1.61.07-2.19a2.67,2.67,0,0,1,.07-.76,4.12,4.12,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84h-.19A8.48,8.48,0,0,1,147.73,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,243.14a10.77,10.77,0,0,1,.09,1.63H158c-.14-4.35-.24-18.76-.24-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.25,35.84H158A9.71,9.71,0,0,1,158.06,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,243.14a9.71,9.71,0,0,1,.1,1.63h-.19c-.15-4.35-.25-18.76-.25-35.84,0-10.3.07-19.63.1-26.49,0-3.32.08-6,.11-8,0-.89.05-1.61.06-2.19a3.23,3.23,0,0,1,.07-.76,3.23,3.23,0,0,1,.07.76c0,.58,0,1.3.06,2.19,0,2,.07,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.1,31.49-.24,35.84h-.19A10.77,10.77,0,0,1,168.39,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,243.14a8.48,8.48,0,0,1,.1,1.63h-.19c-.14-4.35-.25-18.76-.25-35.84,0-10.3.08-19.63.1-26.49.05-3.32.08-6,.11-8,0-.89,0-1.61.06-2.19a4.12,4.12,0,0,1,.07-.76,2.67,2.67,0,0,1,.07.76c0,.58,0,1.3.07,2.19,0,2,.06,4.71.11,8,0,6.86.06,16.19.1,26.49,0,17.08-.11,31.49-.25,35.84h-.19A10.77,10.77,0,0,1,178.72,243.14Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.69,102.27l-7.79,70.19c-1.33,11.94-5.72,29.2-24.49,26.25h0c-16.1-3.8-18.52-19.78-17.27-30.92.59-5.28,1.07-9.69,1.1-10.23,0,0-17.68-3.67-17-21.5.33-8.61,2.44-26.31,4.54-42.29a33.22,33.22,0,0,1,34.62-28.84l1.72.08C277.6,67,286.21,83.85,283.69,102.27Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.24,157.56a43.08,43.08,0,0,0,23.54-5.7s-6.31,12.73-24,10.23Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,104.73c.31.4,2.55-1,5.51-.7s5,2,5.35,1.67c.18-.16-.11-.85-1-1.65a7.48,7.48,0,0,0-4.24-1.79,7.2,7.2,0,0,0-4.43,1C252.26,103.91,251.89,104.55,252,104.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,110.85a2.42,2.42,0,0,0,2.2,2.55,2.31,2.31,0,0,0,2.59-2.05,2.41,2.41,0,0,0-2.2-2.54A2.31,2.31,0,0,0,251.37,110.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09,124.38c0-.16-1.66-.54-4.4-1-.7-.11-1.35-.28-1.45-.76a3.55,3.55,0,0,1,.57-2l2.34-5.22c3.25-7.44,5.64-13.57,5.34-13.69s-3.18,5.79-6.43,13.23q-1.19,2.74-2.25,5.25a4,4,0,0,0-.5,2.73,1.73,1.73,0,0,0,1.1,1.08,4.31,4.31,0,0,0,1.18.22C240.35,124.43,242.07,124.53,242.09,124.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.67,93.77c.21.69,2.63.49,5.45,1s5.07,1.41,5.47.82c.19-.29-.18-1-1.07-1.65a9,9,0,0,0-4-1.68,8.76,8.76,0,0,0-4.31.31C255.14,92.94,254.59,93.44,254.67,93.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,93.77c.25.57,2.63.26,5.43.52s5.09.91,5.45.38c.16-.25-.24-.78-1.16-1.33a9.88,9.88,0,0,0-4-1.19,10.21,10.21,0,0,0-4.24.5C227.29,93,226.78,93.49,226.88,93.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.57,115.39c.31-.12,12.43-3,11.43,9.16s-13,8.64-13,8.29S281.57,115.39,281.57,115.39Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.09,128.54c.06,0,.2.17.55.36a2.1,2.1,0,0,0,1.58.16c1.32-.36,2.57-2.31,2.81-4.5a7,7,0,0,0-.34-3.08,2.46,2.46,0,0,0-1.46-1.76,1.09,1.09,0,0,0-1.3.48c-.19.32-.13.57-.2.59s-.24-.23-.1-.72a1.31,1.31,0,0,1,.54-.72,1.59,1.59,0,0,1,1.19-.22,3,3,0,0,1,2.06,2.07,7.1,7.1,0,0,1,.46,3.45c-.28,2.45-1.72,4.64-3.52,5a2.3,2.3,0,0,1-1.92-.48C284.09,128.84,284.05,128.56,284.09,128.54Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.91,133.11c-.09-.32,2.37-.74,4.31-2.76a13.76,13.76,0,0,0,2.06-2.95c.46-.84.8-1.36.93-1.3s0,.65-.3,1.58a8.92,8.92,0,0,1-2,3.34,7.23,7.23,0,0,1-3.38,2C244.56,133.27,243.93,133.22,243.91,133.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,100.9c.31.4,2.55-1,5.51-.7s5,2,5.35,1.66c.18-.15-.11-.84-1-1.64a7.41,7.41,0,0,0-4.24-1.79,7.2,7.2,0,0,0-4.43,1C226.23,100.08,225.86,100.72,226,100.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.8,107.69a2.42,2.42,0,0,0,2.2,2.55,2.31,2.31,0,0,0,2.59-2,2.39,2.39,0,0,0-2.19-2.54A2.3,2.3,0,0,0,225.8,107.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.18,104.51c-.89,3.39-3,11.12-6,10.43-6-1.36-5.65,8.26-8.55,7.13s-3.58-8.78-3.25-11.83c1-9.53,4.66-16.37.63-27.25a14.5,14.5,0,0,0-12.27-7.23,14.75,14.75,0,0,0-12.54,7c-.62-3.33-2.36-8.33-5.37-9.87a8.64,8.64,0,0,0-9.5,1,7,7,0,0,0-1,9.17,3.37,3.37,0,0,1-3.79-1.27,5.73,5.73,0,0,0,1.59,4.27,5.26,5.26,0,0,1-3.08-2l1,4.12c-5,.25-10.09-4.51-11.59-8.82-2.27-6.54-.79-13.22,2.75-19.16s10-10.22,17-10.32,12.79,3.05,15.6,9.37c4.42-3.28,13.49-4.59,18.54-2.43a16.17,16.17,0,0,1,9.5,12.58c3.1-1.39,6.88-.45,9.57,1.63l.65.54a14.38,14.38,0,0,1,4.48,13.17c-.32,1.92-.94,3.92-1.29,5.47C293.08,94.8,291.18,104.51,291.18,104.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.68,81.53s-.16-.09-.41-.31a7,7,0,0,1-1-1.06,10,10,0,0,1-2.09-5,9.55,9.55,0,0,1,2.17-7.6,10.32,10.32,0,0,1,8.92-3.6,11.42,11.42,0,0,1,4.81,1.76,15.4,15.4,0,0,1,3.59,3.13,18.7,18.7,0,0,1,3.77,7,18.38,18.38,0,0,1,.71,5.35c0,.64-.06,1.13-.11,1.46a2.11,2.11,0,0,1-.09.5,22.31,22.31,0,0,0-.86-7.21,18.84,18.84,0,0,0-3.79-6.84,13.22,13.22,0,0,0-8.09-4.69,9.94,9.94,0,0,0-8.49,3.4,9.25,9.25,0,0,0-2.17,7.24A10.26,10.26,0,0,0,227.41,80C228.16,81.05,228.71,81.49,228.68,81.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.49,86.85a2.87,2.87,0,0,1-.37-.56c-.23-.38-.56-1-1-1.68a36.55,36.55,0,0,1-2.92-6.5,18.76,18.76,0,0,1-.89-4.87,13.75,13.75,0,0,1,.89-5.62,10.86,10.86,0,0,1,3.93-4.9,13.16,13.16,0,0,1,6.35-2.26,16,16,0,0,1,6.68.91,20.92,20.92,0,0,1,5.53,3,16.28,16.28,0,0,1,6.16,8.49,11.88,11.88,0,0,1-.19,7.09,9.62,9.62,0,0,1-.84,1.75,4,4,0,0,1-.4.55,15.61,15.61,0,0,0,1-2.37,11.91,11.91,0,0,0,0-6.92,16.07,16.07,0,0,0-6.09-8.21A18,18,0,0,0,232.57,61a12.83,12.83,0,0,0-6.11,2.17,10.45,10.45,0,0,0-3.77,4.66,13.42,13.42,0,0,0-.91,5.42,18.78,18.78,0,0,0,.81,4.78,40.35,40.35,0,0,0,2.75,6.51l.87,1.73A3.57,3.57,0,0,1,226.49,86.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.85,97c-.06-.08,1.07-.91,2.46-2.65a17.26,17.26,0,0,0,3-16.3c-.69-2.12-1.45-3.3-1.36-3.34s.24.25.57.8a14.41,14.41,0,0,1,1.14,2.42,16.63,16.63,0,0,1-3.06,16.66,15,15,0,0,1-1.92,1.86A3.46,3.46,0,0,1,286.85,97Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,96.9c0-.05.58-.28,1.5-.94a8.55,8.55,0,0,0,2.89-3.64l.46-1.14-.08,1.23c-.11,1.66-.24,3.57-.37,5.65l-.39-.22a15.5,15.5,0,0,0,6.25-10.12,15.94,15.94,0,0,0-.16-5.54,21.84,21.84,0,0,0-1.78-4.83,1.57,1.57,0,0,1,.23.29,9.53,9.53,0,0,1,.54.88,14.46,14.46,0,0,1,1.36,3.58,15.41,15.41,0,0,1-6.16,16.14l-.43.3,0-.52.47-5.64.39.09a8.41,8.41,0,0,1-3.13,3.68,7.08,7.08,0,0,1-1.18.61A1.82,1.82,0,0,1,276.12,96.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.28,72.17a11.33,11.33,0,0,0-2.81-3.33A9.93,9.93,0,0,0,265.19,67a10.54,10.54,0,0,0-5.66.64,12.19,12.19,0,0,0-4.67,3.32,14.42,14.42,0,0,0-2.46,4,28.68,28.68,0,0,0-1.19,4.25,4.06,4.06,0,0,1,.06-1.2,14.62,14.62,0,0,1,.78-3.18,14.37,14.37,0,0,1,2.45-4.22,12.42,12.42,0,0,1,4.84-3.49,10.86,10.86,0,0,1,5.94-.63,10,10,0,0,1,4.42,2.06,8.75,8.75,0,0,1,2.12,2.51,7.27,7.27,0,0,1,.38.81A.87.87,0,0,1,272.28,72.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,63.25A17.35,17.35,0,0,0,266,62.07,11.8,11.8,0,0,0,258,63.4a14.75,14.75,0,0,0-5.59,6.09c-1,1.92-1.27,3.25-1.36,3.22a2.79,2.79,0,0,1,.15-.94,14.8,14.8,0,0,1,.88-2.45A14.19,14.19,0,0,1,257.72,63a11.62,11.62,0,0,1,8.4-1.24,9,9,0,0,1,2.43,1A3.22,3.22,0,0,1,269.32,63.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,340.23,309,341.75s31.25-13.08,39.84-13.43,25.63.74,33.51,13.43c8.15,13.12,9.29,36.26-15.82,53.07-24.46,16.38-136.29,31.51-151.62,30.12L186.67,387s-.29-31.09,0-32.57,5-14.8,5-14.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,392.71l57.91,21.51-26.39,72.17c-6.74-2.94-6.93-45.34-6.93-45.34l-37.67-12.26Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.78,417.59a3.14,3.14,0,0,1,4.11-.81,3,3,0,0,1,.84,4.06c-.87,1.28-3.17,1.82-4.36.84s-1.55-3.3-.4-4.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.07,414.22,316.22,412,293.06,482.2s.22,3.73,2.62,4.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,442.08c.36.12,1.16-1.58,2.93-2.9s3.59-1.7,3.57-2.08-2.25-.59-4.36,1S287.6,442,288,442.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32,450.8c.31.2,1.46-1.1,3.39-1.75s3.63-.43,3.75-.78-1.8-1.31-4.18-.46S288,450.67,288.32,450.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.8,458.41c.2-.29-1.39-1.43-3.65-1.23s-3.63,1.57-3.39,1.83,1.64-.39,3.5-.53S295.64,458.75,295.8,458.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.68,438.34c.37,0,.48-1.83,1.34-3.77s2.06-3.27,1.83-3.56-2,.74-3,3S279.34,438.41,279.68,438.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74,433.49c.15.05.87-1.26,1.31-3.62a17.87,17.87,0,0,0,.22-4.21,20.45,20.45,0,0,0-.34-2.48,5,5,0,0,0-.46-1.4,1.62,1.62,0,0,0-1.81-.85,2.05,2.05,0,0,0-1.37,1.25,5.3,5.3,0,0,0-.31,1.42,13.5,13.5,0,0,0-.05,2.53,13.34,13.34,0,0,0,1,4.14c.94,2.24,2,3.29,2.16,3.2s-.64-1.34-1.29-3.51a15.18,15.18,0,0,1-.64-3.89,14,14,0,0,1,.12-2.31c.08-.84.31-1.49.72-1.56.16,0,.21,0,.38.23a4.3,4.3,0,0,1,.33,1,20.11,20.11,0,0,1,.39,2.3,21.64,21.64,0,0,1,.06,4C272,432,271.55,433.42,271.74,433.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.42,433.21c.1-.1-.91-1.26-3.15-2.23a12.44,12.44,0,0,0-4.13-1,13,13,0,0,0-2.54.12,3.17,3.17,0,0,0-2.66,1.64,1.78,1.78,0,0,0,.45,1.87,5.14,5.14,0,0,0,1.19.86,8.48,8.48,0,0,0,2.44.89,8.65,8.65,0,0,0,4.29-.18c2.39-.72,3.35-2,3.24-2.11s-1.26.79-3.45,1.22a9,9,0,0,1-3.82-.1,8.39,8.39,0,0,1-2.06-.83c-.73-.4-1.24-.91-1.06-1.17s.93-.76,1.65-.83a12.88,12.88,0,0,1,2.28-.18,14.31,14.31,0,0,1,3.87.62C271.11,432.53,272.29,433.39,272.42,433.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,383.79l-56,26,32,69.88c6.48-3.46,3.34-45.75,3.34-45.75l36.59-15.18Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.83,410.92a3.14,3.14,0,0,0-4.16-.49,3,3,0,0,0-.51,4.12c1,1.2,3.29,1.56,4.4.49s1.29-3.41.06-4.34",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,409.78l5.65-2.62,28.61,68.12s.07,3.73-2.28,4.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.57,434.88c-.35.15-1.29-1.49-3.15-2.67s-3.71-1.41-3.72-1.79,2.2-.77,4.43.7S196.91,434.81,196.57,434.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,443.6c-.3.23-1.55-1-3.53-1.48s-3.65-.14-3.79-.48,1.69-1.45,4.13-.79S197.21,443.44,196.89,443.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,451.78c-.21-.28,1.27-1.54,3.54-1.52s3.75,1.28,3.53,1.56-1.67-.26-3.53-.25S190.21,452.1,190,451.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.52,430.5c-.38,0-.62-1.79-1.64-3.65s-2.31-3.1-2.09-3.41,2.08.58,3.25,2.8S204.86,430.54,204.52,430.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,425c-.14.07-1-1.19-1.58-3.51a17.12,17.12,0,0,1-.56-4.18,19.65,19.65,0,0,1,.15-2.49,4.64,4.64,0,0,1,.34-1.44,1.62,1.62,0,0,1,1.74-1,2,2,0,0,1,1.47,1.13A5.2,5.2,0,0,1,214,415a13.88,13.88,0,0,1,.25,2.52,13.72,13.72,0,0,1-.64,4.19c-.76,2.31-1.78,3.45-1.9,3.36s.52-1.38,1-3.6a15.13,15.13,0,0,0,.33-3.92,13.57,13.57,0,0,0-.3-2.3c-.14-.82-.42-1.46-.84-1.5-.16,0-.21,0-.36.26a4.09,4.09,0,0,0-.24,1,19.37,19.37,0,0,0-.21,2.33,20.93,20.93,0,0,0,.25,4C211.73,423.6,212.24,425,212.05,425Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,424.82c-.11-.1.8-1.34,2.95-2.47A12.41,12.41,0,0,1,220.9,421a3.18,3.18,0,0,1,2.79,1.42,1.81,1.81,0,0,1-.31,1.91,5.25,5.25,0,0,1-1.12.95,8.61,8.61,0,0,1-2.36,1.08,8.8,8.8,0,0,1-4.29.16c-2.44-.54-3.5-1.77-3.4-1.86s1.32.7,3.54,1a8.92,8.92,0,0,0,3.8-.4,7.87,7.87,0,0,0,2-1c.69-.45,1.17-1,1-1.24a2.17,2.17,0,0,0-1.7-.7,11.78,11.78,0,0,0-2.3,0,13.75,13.75,0,0,0-3.8.92C212.6,424,211.49,425,211.36,424.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,339.64s-48.26-18-66-15.7c-9.93,1.31-25.46,8.89-26.65,21.62s1.93,29.76,19.1,38.05,85.71,39.05,102,43.78S277,443.22,277,443.22l15.42-44s-84.15-29.14-88.59-32.4-15.69-7.69-15.69-7.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.47,345.61l-.34-.08-1-.3c-.85-.25-2.11-.62-3.75-1a40.88,40.88,0,0,0-14.17-1.05,47.9,47.9,0,0,0-9.66,1.84,34.1,34.1,0,0,0-5.09,2l-5.25,2.57c-7.22,3.45-15.29,7-23.87,10.37-17.2,6.89-33.71,10.16-45.48,12.84-5.9,1.3-10.68,2.38-14,3.16l-3.79.9-1,.22-.34.06a1,1,0,0,1,.32-.11l1-.27c.86-.23,2.12-.59,3.77-1,3.27-.84,8-2,13.93-3.32,11.76-2.77,28.22-6.09,45.36-13,8.58-3.39,16.64-6.9,23.86-10.33l5.26-2.54a34.3,34.3,0,0,1,5.17-2,46.53,46.53,0,0,1,9.75-1.79A40,40,0,0,1,354.46,344c1.64.42,2.89.82,3.74,1.11l.95.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,339.25c0,.09-1.47-.18-3.83-.43a57.54,57.54,0,0,0-18.45.95c-2.33.49-3.75.9-3.77.82a4.26,4.26,0,0,1,1-.39c.63-.22,1.56-.5,2.72-.79a48,48,0,0,1,9.25-1.38,49.09,49.09,0,0,1,9.33.42c1.19.18,2.14.36,2.79.51A4.72,4.72,0,0,1,356.93,339.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,352.4c-.05.07-1.39-1-3.7-2.39a48.78,48.78,0,0,0-19.87-7c-2.7-.34-4.39-.37-4.39-.46a5,5,0,0,1,1.19-.07c.77,0,1.88,0,3.24.16a43.73,43.73,0,0,1,20,7.07,30.2,30.2,0,0,1,2.62,1.91A4.53,4.53,0,0,1,171.4,352.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62,418l.38.14,1.09.46c1,.4,2.38,1.06,4.27,1.79,3.76,1.49,9.31,3.53,16.44,5.88,14.25,4.65,34.74,10.59,59.26,16.76l-.27.15,14.92-41.41.14.33-18.48-7.59L171.14,352.4l0,0,0,0c-4.16-4.4-8-8.28-11.58-11.42a78.49,78.49,0,0,0-9.71-7.31,71.32,71.32,0,0,0-6.66-3.71l-1.79-.84-.6-.3.62.26,1.81.79a65,65,0,0,1,6.72,3.64,76.61,76.61,0,0,1,9.79,7.27c3.62,3.12,7.47,7,11.65,11.38l-.06,0L273.57,394l18.48,7.59.22.09-.08.24-15,41.39-.07.2-.21-.05c-24.52-6.22-45-12.22-59.24-17-7.12-2.38-12.66-4.47-16.41-6-1.88-.74-3.28-1.43-4.24-1.85l-1.08-.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9,185.83s13.9,8,16.72,17.41c1.71,5.71,14.67,78.77,16.72,93.17s-2.28,25.08-8.42,29.86-24.77,11.14-24.77,11.14L289,345.9l-7.51-19.12L306.39,291,304,266.83Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.59,173.21l-10.44-6s-9.51,11.12-22.48,9.76S234,165.72,234,165.72l-38.68,7.87h0c-2.59.52-7.32,2.16-11.85,8.63-5.05,7.21-29,39.2-29,39.2H137.75a12.43,12.43,0,0,0-11,6.64c-2.86,5.45-6.29,12.73-6,15.75.57,5.11-.42,19.12,6.43,23.49,2.17,1.39,9.93,5.55,16,5.27,8.89-.42,19.22-5.05,25.17-9.21,5-3.53,16.75-15.71,21.26-20.46V243l2.9,101.45,101.4-2.88,21-155.72S288.61,173.21,287.59,173.21Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,200.4c.14,0,.41,12.57.59,28.08s.22,28.09.07,28.09-.41-12.57-.59-28.08S189.1,200.4,189.24,200.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,282.41s-.86.14-2.39.43a29.59,29.59,0,0,0-6.28,2,40.93,40.93,0,0,0-8.36,5.05,72.82,72.82,0,0,0-8.81,8.15c-2.9,3.13-5.54,6.22-8,9a97.6,97.6,0,0,1-6.91,7,50.57,50.57,0,0,1-5.19,4.16c-.64.45-1.17.75-1.52,1a2.56,2.56,0,0,1-.55.3,3.14,3.14,0,0,1,.49-.39c.33-.25.84-.58,1.46-1.06a56.12,56.12,0,0,0,5.06-4.26c2.05-1.9,4.34-4.32,6.8-7.09s5.1-5.87,8-9a71.31,71.31,0,0,1,8.9-8.17,39.78,39.78,0,0,1,8.5-5,27.43,27.43,0,0,1,6.39-1.86c.78-.15,1.39-.15,1.8-.2A2.5,2.5,0,0,1,327.18,282.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.48,275.54c0,.09-1.54.31-4,1a36.63,36.63,0,0,0-16.61,9.89c-1.74,1.81-2.67,3.07-2.74,3a4.51,4.51,0,0,1,.58-.93,22.84,22.84,0,0,1,1.89-2.33,33.26,33.26,0,0,1,16.78-10,26.52,26.52,0,0,1,2.95-.55A4.16,4.16,0,0,1,329.48,275.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.75,257.73c5.37,1.46,11.81-6.26,16.69-11.09,2.53-2.52,5.17-5.2,6.11-8.65a13.74,13.74,0,0,0-.85-8.65,31.57,31.57,0,0,0-3.57-6.93c.45,4.17,1.48,10.55.08,15.79-1.17,4.37-3.94,7.84-6.88,11.14-3.1,3.49-6.78,7.15-11.58,8.39"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,253.31c-.1,0,.52-1.77,1-4.68a34.67,34.67,0,0,0,.49-5.15,38,38,0,0,0-.42-6.31,38.77,38.77,0,0,0-1.54-6.14,35.4,35.4,0,0,0-2.06-4.75c-1.37-2.62-2.5-4.08-2.42-4.14a5.51,5.51,0,0,1,.83,1,12.17,12.17,0,0,1,.87,1.24c.32.5.7,1.06,1.05,1.72a32.68,32.68,0,0,1,2.18,4.76,35.72,35.72,0,0,1,1.6,6.22,35.13,35.13,0,0,1,.39,6.41,30.6,30.6,0,0,1-.61,5.21c-.12.74-.31,1.38-.46,2a14.55,14.55,0,0,1-.44,1.45A6.57,6.57,0,0,1,163.7,253.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.24,169.64c.07.13-1.12.82-2.36,1.94s-2.08,2.21-2.2,2.12a7.55,7.55,0,0,1,4.56-4.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,175.77c.11.11-.91,1.2-1.73,2.82s-1.13,3.08-1.28,3a5.62,5.62,0,0,1,.82-3.29A5.68,5.68,0,0,1,248.79,175.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.86,182.13a16.51,16.51,0,0,1-1.16-3,15.21,15.21,0,0,1-1-3.07,7.76,7.76,0,0,1,1.52,2.9A7.48,7.48,0,0,1,266.86,182.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,176.63c-.16,0-.55-1.73-1.7-3.6s-2.51-3.05-2.4-3.17a7,7,0,0,1,2.85,2.9A7,7,0,0,1,278.49,176.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,209.49c.15,0-1.57,13.88-3.83,30.95s-4.21,30.9-4.35,30.88,1.57-13.87,3.83-30.95S311.73,209.47,311.87,209.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,231.93a8.63,8.63,0,0,1,0,1.43,11,11,0,0,1-.21,1.67c-.06.33-.11.67-.18,1s-.18.74-.29,1.14a30.73,30.73,0,0,1-2,5.45,37.86,37.86,0,0,1-3.73,6.05,32.1,32.1,0,0,1-5,5.1,21.67,21.67,0,0,1-5,3c-.39.15-.75.32-1.1.45l-1,.28-.88.24c-.27.06-.53.07-.76.11a8.9,8.9,0,0,1-1.43.11,25.8,25.8,0,0,0,5-1.53,22.67,22.67,0,0,0,4.82-3,33.38,33.38,0,0,0,4.84-5,38.77,38.77,0,0,0,3.7-5.94,33.28,33.28,0,0,0,2.08-5.34A51.6,51.6,0,0,0,159.92,231.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.61,347.9c4.3-2.08,5.28-7.65,5.72-12.41q1.92-20.89,3.85-41.81c.61-6.55.9-14-3.72-18.72-4.22-4.28-10.93-4.53-16.94-4.51-37.1.1-69.87,1.19-107,1.29l1.89,64.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,281.8l3.95,75.28a5.5,5.5,0,0,0,5.52,5.18l119.92.21a5.51,5.51,0,0,0,5.52-5.2l4.57-74c.16-3.08-2-7.17-5.14-7.23H180.18A5.49,5.49,0,0,0,174.55,281.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,281.8s0-.1,0-.28a4.48,4.48,0,0,1,0-.84,5.44,5.44,0,0,1,1.42-2.93,5.58,5.58,0,0,1,2-1.37,7.09,7.09,0,0,1,2.9-.4l7.29,0,46.46-.08,68.91-.07h4.9a4.27,4.27,0,0,1,2.47.63,6.16,6.16,0,0,1,1.83,1.8,8.62,8.62,0,0,1,1.51,4.86c-.1,1.67-.2,3.36-.3,5.06q-.63,10.16-1.28,20.73c-.86,14.09-1.76,28.67-2.69,43.61l-.17,2.8c-.08.93-.06,1.83-.23,2.81a5.75,5.75,0,0,1-3.62,4.25,6.8,6.8,0,0,1-2.81.37h-8.25l-21.53,0-40.7-.09-36.83-.09-8.5,0H185.3c-.69,0-1.37,0-2.09-.07a5.71,5.71,0,0,1-3.59-2,5.79,5.79,0,0,1-1.34-3.79c-.07-1.31-.13-2.6-.2-3.88-.13-2.57-.26-5.07-.39-7.52-1-19.59-1.79-35.44-2.35-46.4-.26-5.47-.47-9.72-.61-12.62-.06-1.44-.11-2.53-.15-3.28s0-1.12,0-1.12,0,.38.09,1.12.11,1.84.19,3.27c.17,2.9.41,7.15.72,12.62.59,11,1.45,26.81,2.51,46.39.13,2.45.27,4.95.41,7.52.06,1.28.13,2.57.2,3.88a5.4,5.4,0,0,0,1.26,3.55,5.28,5.28,0,0,0,3.34,1.84,16.89,16.89,0,0,0,2,.06h10.57l36.83,0,40.7.06,21.53,0h8.25a6.41,6.41,0,0,0,2.63-.34A5.22,5.22,0,0,0,309.1,358c.15-.85.15-1.83.22-2.74l.17-2.8c.93-14.94,1.83-29.52,2.71-43.6q.65-10.58,1.28-20.74c.11-1.69.21-3.37.31-5.05a8.14,8.14,0,0,0-1.42-4.56,4.44,4.44,0,0,0-3.91-2.22h-4.89l-68.91,0-46.46-.07-7.29,0a7,7,0,0,0-2.85.37,5.46,5.46,0,0,0-3.42,4.19A10.17,10.17,0,0,0,174.55,281.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.18,
    cy: 318.52,
    r: 7.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,318.52c-.05,0,0-.63-.32-1.7a7,7,0,0,0-2.58-3.77,6.73,6.73,0,0,0-2.9-1.26,6.94,6.94,0,0,0-3.58.32,6.72,6.72,0,0,0-3.16,2.38,6.83,6.83,0,0,0,6.74,10.75,6.73,6.73,0,0,0,2.9-1.26,7,7,0,0,0,2.58-3.76c.29-1.07.27-1.71.32-1.7a1.29,1.29,0,0,1,0,.45,5.12,5.12,0,0,1-.15,1.3,7.07,7.07,0,0,1-2.55,4,7.22,7.22,0,0,1-6.88,1.1,7.28,7.28,0,0,1-3.4-11.19,7.16,7.16,0,0,1,3.4-2.53,7.25,7.25,0,0,1,3.83-.29,7.09,7.09,0,0,1,3,1.39,7,7,0,0,1,2.55,4,5,5,0,0,1,.15,1.29A1.38,1.38,0,0,1,252.24,318.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,290.13c.14,0,.74,12.65,1.32,28.26s.94,28.27.8,28.27S180,334,179.39,318.4,178.45,290.14,178.59,290.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,191.91c-.71-.6,2.37-12.42,2.37-12.42s-8.14-13.27-8.35-17.55,3.21-13.06,3.21-13.06l23.33-6s7.5,13.92,9,18.84-2.57,21.62-2.57,21.62l-4,8.57S153.66,201.33,142.55,191.91Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,164.5a52.93,52.93,0,0,1-2.46-5.19c-1.47-3.5-3.29-6.94,0-8.9a4.3,4.3,0,0,1,3.52-.55s-.5-3,1.26-4.06a3.82,3.82,0,0,1,3.46-.3s-.56-4.16,2-5.92a6.14,6.14,0,0,1,6.46-.19s-2-18.21-2.18-19.17c-.64-3.54.67-6.68,4.19-5.8,1.29.32,2,1.68,3.52,7.61s3.95,16.05,3.95,16.05,4.1,7.12,6,11,5.77,12.66,6.09,15c.82,6-2.71,14-2.71,14l-24.8,1.44Z",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.16,150.64a21.7,21.7,0,0,1,1.92,2.68l2,3a13.57,13.57,0,0,1,1.07,1.86,3.8,3.8,0,0,1,.29,2.37,2.4,2.4,0,0,1-1.57,1.84,3.09,3.09,0,0,1-2.22-.28,10.18,10.18,0,0,1-1.66-1c-.48-.35-.93-.69-1.33-1-.81-.63-1.43-1.17-1.85-1.56s-.64-.61-.62-.64,1,.73,2.69,1.9a20.69,20.69,0,0,0,3,1.88,2.66,2.66,0,0,0,1.87.23,1.87,1.87,0,0,0,1.21-1.47,3.3,3.3,0,0,0-.25-2,13.62,13.62,0,0,0-1-1.8l-1.87-3A20.56,20.56,0,0,1,138.16,150.64Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,152.81a8.61,8.61,0,0,1,.26-3.9,8.33,8.33,0,0,1,1.55-3.59c.14.07-.55,1.66-1,3.71S158.66,152.81,158.5,152.81Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,158.13a16.46,16.46,0,0,0-8.3-4.33,31.18,31.18,0,0,0-9.45-.36c-2.52.23-5.41.88-6.55,3.14s.24,5.32,2.47,6.65,5,1.39,7.61,1.16,5.21-.72,7.79-.32",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,164.07s-.7-.07-2,0a52.82,52.82,0,0,0-5.31.5,22.2,22.2,0,0,1-3.73.16,10.24,10.24,0,0,1-4.18-1.05,6.47,6.47,0,0,1-3.1-3.61,5,5,0,0,1-.18-2.58,4.51,4.51,0,0,1,1.37-2.3,9,9,0,0,1,4.77-1.85,40.93,40.93,0,0,1,4.71-.28,23.87,23.87,0,0,1,7.89,1.19,15.72,15.72,0,0,1,4.73,2.56,10.15,10.15,0,0,1,1.09,1,1.93,1.93,0,0,1,.33.39s-.52-.47-1.54-1.21a16.71,16.71,0,0,0-4.73-2.37,24.14,24.14,0,0,0-7.76-1.06,42,42,0,0,0-4.65.31,8.47,8.47,0,0,0-4.49,1.73,3.92,3.92,0,0,0-1.21,2,4.42,4.42,0,0,0,.15,2.31,6,6,0,0,0,2.85,3.35,9.74,9.74,0,0,0,4,1,23,23,0,0,0,3.66-.09,41.65,41.65,0,0,1,5.36-.35,14.18,14.18,0,0,1,1.45.14A1.79,1.79,0,0,1,161.91,164.07Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,150.93c2.61,4,4.91,8.32,7.11,12.52a7.69,7.69,0,0,0,2.5,3.24c.94.58,3.27-.47,4.32-.83l-7.17-16.3",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,149.56a7.31,7.31,0,0,1,.64,1.21l1.58,3.42c1.33,2.9,3.15,7,5.18,11.57l.12.25-.27.1c-.77.27-1.6.62-2.5.85a5.61,5.61,0,0,1-1.1.16,1.94,1.94,0,0,1-.58-.06,1.37,1.37,0,0,1-.54-.27,5.57,5.57,0,0,1-1.45-1.54c-.73-1.16-1.25-2.32-1.84-3.39-1.12-2.17-2.15-4.11-3.05-5.73s-1.64-2.91-2.17-3.8a11.56,11.56,0,0,1-.78-1.4,8,8,0,0,1,.95,1.3c.58.85,1.39,2.12,2.32,3.72s2,3.52,3.16,5.68c.59,1.07,1.14,2.25,1.84,3.34a5.29,5.29,0,0,0,1.31,1.4,2.14,2.14,0,0,0,1.8.08c.85-.21,1.66-.55,2.46-.83L152,166c-2-4.61-3.78-8.7-5-11.64l-1.44-3.48A7.92,7.92,0,0,1,145.1,149.56Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.17,144.71q3.45,8.67,6.91,17.33a11.78,11.78,0,0,0,1.86,3.48,4,4,0,0,0,3.48,1.51c1.8-.26,3-2.17,3.07-4a12.87,12.87,0,0,0-1.3-5.26,109.55,109.55,0,0,1-4.95-16.22",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.24,141.56a3.73,3.73,0,0,1,.17.53c.11.4.24.91.41,1.53.36,1.33.88,3.25,1.61,5.6s1.67,5.12,2.86,8.14a17,17,0,0,1,1.45,5,5.48,5.48,0,0,1-.53,2.76,4.06,4.06,0,0,1-2.07,2,3.48,3.48,0,0,1-2.91-.24,5.46,5.46,0,0,1-2-1.92,30.93,30.93,0,0,1-2.09-4.71c-1.18-3-2.24-5.74-3.15-8.05s-1.56-4.1-2.08-5.45l-.55-1.49a2.35,2.35,0,0,1-.15-.54,2.59,2.59,0,0,1,.25.5l.64,1.45c.55,1.34,1.31,3.17,2.23,5.39s2,5,3.26,8a30.8,30.8,0,0,0,2.07,4.6,4.91,4.91,0,0,0,1.85,1.74,3,3,0,0,0,2.48.21,3.53,3.53,0,0,0,1.8-1.77,4.93,4.93,0,0,0,.48-2.5,16.89,16.89,0,0,0-1.39-4.81c-1.17-3-2.08-5.85-2.76-8.21s-1.16-4.32-1.46-5.66c-.14-.68-.25-1.2-.31-1.56A1.77,1.77,0,0,1,152.24,141.56Z",
    style: {
      fill: "#6f4c47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.72,185.34S127.9,232,127.27,234.28s3.13,18.95,10,22.9,20.2-12.49,21.86-18.53,0-16.24,0-16.24l10.67-40.19",
    style: {
      fill: "#936760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.13,178.09a3,3,0,0,1-1.49-.19,8.27,8.27,0,0,1-3.14-1.81,8.15,8.15,0,0,1-2.08-3,2.92,2.92,0,0,1-.32-1.47,13.46,13.46,0,0,0,2.75,4.07A13.22,13.22,0,0,0,159.13,178.09Z",
    style: {
      fill: "#6f4c47"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.32,404.22c0,.15-88.11.27-196.78.27s-196.8-.12-196.8-.27,88.1-.26,196.8-.26S443.32,404.08,443.32,404.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.92,
    y: 69.74,
    width: 122.81,
    height: 41.7,
    rx: 5.29,
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,111.43H83.59A5.65,5.65,0,0,1,78,105.79V75.23a5.65,5.65,0,0,1,5.64-5.64H191.52a5.65,5.65,0,0,1,5.64,5.64v30.56A5.65,5.65,0,0,1,191.52,111.43ZM83.59,70.59A4.65,4.65,0,0,0,79,75.23v30.56a4.64,4.64,0,0,0,4.64,4.64H191.52a4.64,4.64,0,0,0,4.64-4.64V75.23a4.65,4.65,0,0,0-4.64-4.64Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,90a4.81,4.81,0,0,1,8.33-3l-1.3,1.2a2.77,2.77,0,0,0-2.19-1,2.79,2.79,0,0,0,0,5.58,2.78,2.78,0,0,0,2.19-1L98.83,93a4.8,4.8,0,0,1-8.33-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.18,85.63h2v7.09h4.38v1.64h-6.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,85.63h2v8.73h-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,90a4.8,4.8,0,0,1,8.32-3l-1.29,1.2a2.79,2.79,0,0,0-2.2-1,2.79,2.79,0,1,0,0,5.58,2.8,2.8,0,0,0,2.2-1L119.57,93a4.79,4.79,0,0,1-8.32-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.11,90.93l-1.18,1.22v2.21h-2V85.63h2v4.08l3.87-4.08H129l-3.61,3.89,3.83,4.84H126.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,85.63v8.73h-2V90.78h-4v3.58h-2V85.63h2v3.45h4V85.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5,92.74v1.62h-6.76V85.63h6.6v1.63h-4.59v1.89h4.05v1.57h-4.05v2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,94.36,156,91.93h-1.86v2.43h-2V85.63h3.78c2.33,0,3.79,1.21,3.79,3.17a2.84,2.84,0,0,1-1.8,2.76l2,2.8Zm-1.89-7.08h-1.65v3h1.65c1.23,0,1.85-.57,1.85-1.52S157,87.28,155.77,87.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,92.74v1.62h-6.76V85.63h6.59v1.63h-4.58v1.89h4v1.57h-4v2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.61,110.51a10.9,10.9,0,0,1-2.1-2.62,10.93,10.93,0,0,1-1.68-2.91,11.07,11.07,0,0,1,2.11,2.62A10.72,10.72,0,0,1,192.61,110.51Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.66,78.28a26.28,26.28,0,0,1-3.31-4.12,28.07,28.07,0,0,1-2.89-4.42,26.28,26.28,0,0,1,3.31,4.12A27.23,27.23,0,0,1,196.66,78.28Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.23,105c-.15.11-1.65-2-3.29-4.82-.83-1.38-1.56-2.64-2.07-3.56a7.52,7.52,0,0,1-.78-1.53c.15-.1,1.65,2.06,3.29,4.82.83,1.38,1.56,2.64,2.08,3.56A7.1,7.1,0,0,1,196.23,105Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69,96.26c-.15.11-1.75-2.22-3.52-5.19-.89-1.49-1.68-2.84-2.24-3.83a8.91,8.91,0,0,1-.84-1.64c.15-.1,1.75,2.23,3.53,5.2.89,1.48,1.67,2.84,2.23,3.82A8.5,8.5,0,0,1,196.69,96.26Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.68,87.63c-.15.11-1.76-2.24-3.54-5.22-.9-1.49-1.69-2.86-2.25-3.85a8.53,8.53,0,0,1-.85-1.65c.15-.1,1.76,2.24,3.54,5.23.9,1.49,1.69,2.85,2.25,3.85A8,8,0,0,1,196.68,87.63Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.89,76.2a40.07,40.07,0,0,1-6.35-1.39,41,41,0,0,1-6.22-1.9,40.07,40.07,0,0,1,6.35,1.39A40.54,40.54,0,0,1,64.89,76.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,68.69A98.32,98.32,0,0,1,59.45,61a96.6,96.6,0,0,1-6.24-8,100.63,100.63,0,0,1,6.65,7.7A100.65,100.65,0,0,1,66.1,68.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.37,65.07A18,18,0,0,1,74,59.8a17.21,17.21,0,0,1-.22-5.44c.15,0,.29,2.42.73,5.37S75.52,65,75.37,65.07Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickChatbot);
export default __webpack_public_path__ + "static/media/click-chatbot.b751b2cf1446c7e27a79b02a5c2456e0.svg";
export { ForwardRef as ReactComponent };